import { useEffect } from 'react';
import Header from '../../../components/base/Header';
import Footer from '../../../components/base/Footer';
import { Link } from 'react-router-dom';

export default function WinterChristmasRoseBlog() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-rose-50 to-orange-50">
      <Header />

      {/* Hero Section */}
      <section className="relative py-16 bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block mb-6">
              <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
                <i className="ri-flower-line text-5xl text-white"></i>
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              【第3弾】季節の花の楽しみ方：クリスマスローズ編
            </h1>
            <p className="text-xl text-white/90 mb-6">
              ──冬の貴婦人と呼ばれる、優美な花──
            </p>
            <div className="flex items-center justify-center gap-4 text-white/90">
              <span className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                2025年11月6日
              </span>
              <span className="flex items-center">
                <i className="ri-user-line mr-2"></i>
                蘭ラ々
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Image */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/8ca6952e6a33257e04fb8ac67bcd75fe/3a83070bed90e40fafef6bc6f386223e.jpeg"
                alt="蘭ラ々"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <article className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            {/* Introduction */}
            <div className="mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                わんわん！モモちゃん畑の蘭ラ々だよ🐾<br />
                今日はボクが大好きな<br />
                <span className="font-bold text-green-700">クリスマスローズ</span> について紹介するね！
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                ボクのママ・蘭ちゃんが毎年大切に育てているお花なんだ。<br />
                冬の寒い時期に、うつむき加減に咲く姿が<br />
                とっても優雅で美しいんだよ✨
              </p>
            </div>

            {/* Section 1 */}
            <div className="mb-12 bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-green-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌸</span>
                クリスマスローズってどんな花？
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  クリスマスローズは、<br />
                  <span className="font-bold text-green-700">「冬の貴婦人」</span> とも呼ばれる美しい花。<br />
                  名前に「クリスマス」って付いているけど、<br />
                  実は2月～4月頃に咲く品種が多いんだって！
                </p>
                <p>
                  うつむき加減に咲く姿が、<br />
                  まるで恥ずかしがり屋さんみたいで可愛いんだ💕
                </p>
                <div className="bg-white rounded-2xl p-6 my-6 border-l-4 border-green-400">
                  <p className="text-green-700 font-medium text-lg">
                    ボクもちょっと恥ずかしがり屋だから、<br />
                    クリスマスローズの気持ちがわかる気がするよ🐶
                  </p>
                </div>
                <p className="font-medium text-green-800">
                  花びらに見える部分は実は「がく片」で、<br />
                  だから長い間美しさを保ってくれるんだって。<br />
                  ママが教えてくれたよ！
                </p>
              </div>
            </div>

            {/* Section 2 */}
            <div className="mb-12 bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-teal-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🎨</span>
                クリスマスローズの色と種類
              </h2>
              <h3 className="text-xl font-bold text-teal-700 mb-6">
                ──ボクが見てきた美しい子たち
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ママの庭には、いろんな色のクリスマスローズがあるんだ。<br />
                  ボクが散歩しながら見てきた子たちを紹介するね！
                </p>
                <div className="grid md:grid-cols-3 gap-4 my-6">
                  <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <div className="text-4xl mb-3">🤍</div>
                    <h3 className="text-lg font-bold text-gray-600 mb-2">ホワイト</h3>
                    <p className="text-sm text-gray-600">清楚で上品<br />雪みたいに綺麗</p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <div className="text-4xl mb-3">🩷</div>
                    <h3 className="text-lg font-bold text-pink-600 mb-2">ピンク</h3>
                    <p className="text-sm text-gray-600">優しい色合い<br />ボクのお気に入り</p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md text-center">
                    <div className="text-4xl mb-3">💜</div>
                    <h3 className="text-lg font-bold text-purple-600 mb-2">パープル</h3>
                    <p className="text-sm text-gray-600">神秘的な雰囲気<br />大人っぽい</p>
                  </div>
                </div>
                <p>
                  他にも、グリーンやブラック、<br />
                  スポット模様が入った子もいるんだよ。<br />
                  どの子も個性的で美しいんだ！
                </p>
                <div className="bg-white rounded-2xl p-6 my-6">
                  <p className="text-gray-700 mb-4">
                    ボクが一番好きなのは、<br />
                    <span className="font-bold text-teal-700">淡いピンクの八重咲き</span>。<br />
                    ふわふわしてて、ボクの毛みたいだから（笑）
                  </p>
                  <p className="text-gray-700">
                    ママは「ダブル咲き」って呼んでるよ。<br />
                    花びらがたくさん重なって、<br />
                    まるでドレスを着た貴婦人みたいなんだ👗
                  </p>
                </div>
              </div>
            </div>

            {/* Section 3 */}
            <div className="mb-12 bg-gradient-to-br from-emerald-50 to-green-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-emerald-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌱</span>
                ママから教わった育て方のコツ
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ボクはいつもママの庭仕事を見てるから、<br />
                  クリスマスローズの育て方も覚えちゃったよ！<br />
                  ママが大切にしているポイントを教えるね🐾
                </p>
                <div className="space-y-6 my-6">
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                        <span className="text-2xl font-bold text-emerald-700">①</span>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-emerald-800 mb-2">
                          半日陰が大好き
                        </h3>
                        <p className="text-gray-700">
                          クリスマスローズは、強い日差しが苦手。<br />
                          木の下や建物の陰など、<br />
                          午前中だけ日が当たる場所が理想的なんだって。<br />
                          ボクのお昼寝スポットと同じだね（笑）
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                        <span className="text-2xl font-bold text-emerald-700">②</span>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-emerald-800 mb-2">
                          水やりは控えめに
                        </h3>
                        <p className="text-gray-700">
                          土の表面が乾いたら、たっぷりあげる。<br />
                          でも、水のやりすぎは根腐れの原因になるから注意！<br />
                          ママは「メリハリが大事」って言ってたよ。
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <div className="flex items-start">
                      <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center flex-shrink-0 mr-4">
                        <span className="text-2xl font-bold text-emerald-700">③</span>
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-emerald-800 mb-2">
                          古い葉っぱは取り除く
                        </h3>
                        <p className="text-gray-700">
                          冬の終わりに、古くなった葉を切り取ると、<br />
                          新しい花がよく見えるようになるんだ。<br />
                          ボクもママのお手伝いで、<br />
                          切った葉っぱを運ぶお仕事してるよ🐶
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="font-medium text-emerald-800 text-lg text-center">
                  この3つを守れば、<br />
                  毎年美しい花を咲かせてくれるよ！
                </p>
              </div>
            </div>

            {/* Section 4 */}
            <div className="mb-12 bg-gradient-to-br from-pink-50 to-rose-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-rose-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🐾</span>
                ボクとクリスマスローズの思い出
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  ボクがまだ子犬だった頃、<br />
                  初めてクリスマスローズを見たときのこと、<br />
                  今でも覚えてるんだ。
                </p>
                <p>
                  まだ雪が残る寒い朝、<br />
                  ママと一緒に庭に出たら、<br />
                  うつむいて咲く小さな花を見つけたんだ。
                </p>
                <div className="bg-white rounded-2xl p-8 my-6 text-center border-2 border-rose-200">
                  <p className="text-xl font-bold text-rose-800 mb-4">
                    「こんなに寒いのに、<br />
                    頑張って咲いてるんだね」
                  </p>
                  <p className="text-lg text-gray-700">
                    ってママが言ってた。<br />
                    その言葉を聞いて、ボクも頑張ろうって思ったんだ。
                  </p>
                </div>
                <p>
                  それから毎年、クリスマスローズが咲く季節になると、<br />
                  ボクとママは一緒に庭を見回るのが日課になったよ。
                </p>
                <p className="font-medium text-rose-800">
                  「今年はどんな色が咲くかな？」<br />
                  「この子、去年より大きくなったね」<br />
                  そんな会話をしながら過ごす時間が、<br />
                  ボクは大好きなんだ💕
                </p>
              </div>
            </div>

            {/* Section 5 */}
            <div className="mb-12 bg-gradient-to-br from-green-50 to-teal-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-green-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">💐</span>
                クリスマスローズの花言葉
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  クリスマスローズの花言葉は、<br />
                  <span className="font-bold text-green-700">「私の不安を和らげて」「慰め」「追憶」</span>。
                </p>
                <p>
                  ちょっと切ない花言葉だけど、<br />
                  寒い冬にそっと寄り添ってくれる<br />
                  優しい花だからこその言葉なんだって。
                </p>
                <div className="bg-white rounded-2xl p-8 my-6 text-center border-2 border-green-200">
                  <p className="text-2xl font-bold text-green-800 mb-4">
                    ボクにとっては、<br />
                    「いつもそばにいるよ」
                  </p>
                  <p className="text-lg text-gray-700">
                    っていう花言葉がぴったりだと思うんだ。<br />
                    だって、寒い冬も春も、<br />
                    ずっと庭で咲いててくれるから🌸
                  </p>
                </div>
              </div>
            </div>

            {/* Section 6 */}
            <div className="mb-12 bg-gradient-to-br from-cyan-50 to-sky-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-cyan-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🌈</span>
                クリスマスローズの楽しみ方
              </h2>
              <h3 className="text-xl font-bold text-cyan-700 mb-6">
                ──ボクのおすすめ
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  クリスマスローズは、いろんな楽しみ方があるんだよ。<br />
                  ボクが見てきた素敵な楽しみ方を紹介するね！
                </p>
                <div className="space-y-6 my-6">
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h3 className="text-xl font-bold text-cyan-700 mb-3 flex items-center">
                      <span className="mr-2">🏡</span>
                      庭植えで群生を楽しむ
                    </h3>
                    <p className="text-gray-700">
                      たくさん植えると、春先に一斉に咲いて<br />
                      まるで花の絨毯みたいになるんだ。<br />
                      ボクはその上を走り回るのが大好き！<br />
                      （ママには怒られるけど…笑）
                    </p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h3 className="text-xl font-bold text-cyan-700 mb-3 flex items-center">
                      <span className="mr-2">🪴</span>
                      鉢植えで玄関を彩る
                    </h3>
                    <p className="text-gray-700">
                      鉢植えにすれば、玄関やベランダでも楽しめるよ。<br />
                      お客さんが来たとき、<br />
                      「わぁ、素敵！」って言ってくれるんだ。<br />
                      ボクも嬉しくなっちゃう🐾
                    </p>
                  </div>
                  <div className="bg-white rounded-2xl p-6 shadow-md">
                    <h3 className="text-xl font-bold text-cyan-700 mb-3 flex items-center">
                      <span className="mr-2">💐</span>
                      切り花として飾る
                    </h3>
                    <p className="text-gray-700">
                      うつむいて咲くから、<br />
                      浅めの器に浮かべるように飾ると綺麗なんだって。<br />
                      ママがよくリビングに飾ってるよ。<br />
                      ボクもその横でお昼寝するのが好き💤
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 7 */}
            <div className="mb-12 bg-gradient-to-br from-emerald-50 to-green-50 rounded-3xl p-8">
              <h2 className="text-3xl font-bold text-emerald-800 mb-6 flex items-center">
                <span className="text-4xl mr-3">🐶</span>
                蘭ラ々からのメッセージ
              </h2>
              <h3 className="text-xl font-bold text-emerald-700 mb-6">
                ──冬の庭で見つける小さな幸せ
              </h3>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  クリスマスローズは、<br />
                  寒い冬にそっと咲く控えめな花。
                </p>
                <p>
                  でも、その優しさと強さは、<br />
                  ボクたちに大切なことを教えてくれるんだ。
                </p>
                <div className="bg-white rounded-2xl p-8 my-6 text-center border-2 border-emerald-200">
                  <p className="text-2xl font-bold text-emerald-800 mb-4">
                    「どんなに寒くても、<br />
                    春は必ず来る」
                  </p>
                  <p className="text-lg text-gray-700 mb-4">
                    「小さくても、<br />
                    自分らしく咲けばいい」
                  </p>
                  <p className="text-lg text-gray-700">
                    クリスマスローズを見ていると、<br />
                    そんなメッセージが聞こえてくる気がするんだ。
                  </p>
                </div>
                <p className="font-medium text-emerald-800">
                  ボクもクリスマスローズみたいに、<br />
                  ママのそばで、自分らしく過ごしていきたいな。
                </p>
                <p className="text-center text-lg font-medium text-emerald-700 mt-6">
                  みんなも、冬の庭で<br />
                  クリスマスローズを見つけたら、<br />
                  ぜひ優しく見守ってあげてね🌸<br />
                  <br />
                  わんわん！また会おうね🐾
                </p>
              </div>
            </div>

            {/* Tags */}
            <div className="flex flex-wrap gap-2 mb-12">
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #クリスマスローズ
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #冬の花
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #季節の花
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #育て方
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #花言葉
              </span>
              <span className="px-4 py-2 bg-rose-100 text-rose-700 text-sm rounded-full">
                #蘭ラ々
              </span>
            </div>

            {/* Back Button */}
            <div className="text-center">
              <Link
                to="/essay"
                className="inline-flex items-center bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white font-bold py-4 px-8 rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-arrow-left-line mr-2"></i>
                エッセイ一覧に戻る
              </Link>
            </div>
          </div>
        </div>
      </article>

      {/* Related Posts */}
      <section className="py-16 bg-gradient-to-br from-pink-50 to-rose-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-rose-800 mb-8 text-center">
              他のブログ記事も読む
            </h2>
            <div className="text-center">
              <Link
                to="/essay"
                className="inline-flex items-center text-rose-600 hover:text-rose-700 font-medium transition-colors"
              >
                すべての記事を見る
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
